export default {
      id: "ic-alert-usage",
      viewBox: "0 0 40 40",
      url: "/" + "images/icons.3.109.2.svg#ic-alert-usage",
      toString: function () {
        return this.url;
      }
    }